import axios from 'axios';

export default {
  loadPPTRA () {
    return new Promise(resolve => {
      axios.get(`https://strapi.arlingtonva.us/pptra`).then((result) => {
        resolve(result.data);
      });
    })
  }
}
